import React from 'react';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import FlagIcon from '@mui/icons-material/Flag';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import TrafficIcon from '@mui/icons-material/Traffic';
import SpeedIcon from '@mui/icons-material/Speed';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import { Container, Header, HeaderLeft, BackButton, Title, Content, MainSection } from '../common/styles';
import { StyledCard, StyledIconButton } from '../LandingPage/styles';
import { useAbility } from '../../contexts/AbilityContext';
import { ACTIONS, SUBJECTS } from '../../constants/permissions';

const configCards = [
  {
    id: 'goal-status',
    title: 'Goal Status',
    description: 'Configure goal status options like Active, Completed, On Hold',
    icon: <FlagIcon />,
    path: '/idp-configuration/goal-status',
    customIconStyle: {
      backgroundColor: '#4CAF50',
    },
    permission: {
      action: ACTIONS.MANAGE,
      subject: SUBJECTS.IDP_GOAL_STATUS
    }
  },
  {
    id: 'goal-status-transitions',
    title: 'Goal Status Transitions',
    description: 'Configure allowed status transitions between goal statuses',
    icon: <SwapHorizIcon />,
    path: '/idp-configuration/goal-status-transitions',
    customIconStyle: {
      backgroundColor: '#2196F3',
    },
    permission: {
      action: ACTIONS.MANAGE,
      subject: SUBJECTS.IDP_GOAL_STATUS_TRANSITION
    }
  },
  {
    id: 'rag-status',
    title: 'RAG Status',
    description: 'Configure RAG (Red/Amber/Green) status options for tracking',
    icon: <TrafficIcon />,
    path: '/idp-configuration/rag-status',
    customIconStyle: {
      backgroundColor: '#FF9800',
    },
    permission: {
      action: ACTIONS.MANAGE,
      subject: SUBJECTS.IDP_RAG_STATUS
    }
  },
  {
    id: 'measurement-type',
    title: 'Measurement Type',
    description: 'Configure measurement types like Checklist, Progress, RAG',
    icon: <SpeedIcon />,
    path: '/idp-configuration/measurement-type',
    customIconStyle: {
      backgroundColor: '#9C27B0',
    },
    permission: {
      action: ACTIONS.MANAGE,
      subject: SUBJECTS.IDP_MEASUREMENT_TYPE
    }
  },
  {
    id: 'resource-templates',
    title: 'Resource Templates',
    description: 'Configure development resource templates and categories',
    icon: <LibraryBooksIcon />,
    path: '/idp-configuration/resource-templates',
    customIconStyle: {
      backgroundColor: '#00BCD4',
    },
    permission: {
      action: ACTIONS.MANAGE,
      subject: SUBJECTS.IDP_RESOURCE_TEMPLATE
    }
  }
];

const IDPConfiguration = () => {
  const navigate = useNavigate();
  const ability = useAbility();

  const visibleCards = configCards.filter(card => {
    if (!card.permission) {
      return true;
    }
    return ability.can(card.permission.action, card.permission.subject);
  });

  return (
    <Container>
      <Header>
        <HeaderLeft>
          <BackButton onClick={() => navigate('/')}>
            <FaArrowLeft /> Back to Home
          </BackButton>
          <Title>IDP Configuration</Title>
        </HeaderLeft>
      </Header>

      <Content>
        <MainSection>
          <Typography variant="body1" paragraph>
            Select a configuration option to manage IDP settings
          </Typography>

          <Grid container spacing={3}>
            {visibleCards.map((card) => (
              <Grid item xs={12} md={6} key={card.id}>
                <StyledCard onClick={() => navigate(card.path)}>
                  <StyledIconButton
                    sx={{
                      ...card.customIconStyle,
                      '&:hover': {
                        ...card.customIconStyle
                      }
                    }}
                  >
                    {card.icon}
                  </StyledIconButton>
                  <Typography variant="h6" align="center">{card.title}</Typography>
                  <Typography variant="body2" color="textSecondary" align="center">
                    {card.description}
                  </Typography>
                </StyledCard>
              </Grid>
            ))}
          </Grid>
        </MainSection>
      </Content>
    </Container>
  );
};

export default IDPConfiguration;
